<template>
    <div class="flex location">
        <v-checkbox background-color="white" class="checkbox" hide-details color="success" v-model="checkbox"/>
        <p class="location-item">{{item}}</p>   
    </div>
</template>


<script>
	export default {
  		name:'checkboxitem',
        props: {
            item: String
        },
        data () {
            return {
                checkbox: false,
            }
        },  
    }
</script>


<style scoped>  
.location{
    column-gap: 8px;
    width: 40%;
    justify-content: start;    
}
.checkbox{
    width: 30px;
    height: 30px;
}
.v-input--selection-controls{
    margin-top: 6px;
}
.location-item{
    margin: 0px;
}
.v-application p {
    margin-top: 6px;
    font-size: 0.9rem;
    margin-bottom: 0px;
}
</style>